"use client";

import { Input } from "@headlessui/react";
import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

const SelectPatientMail = ({ user, search = "", onSearchChange }) => {
  const [localSearch, setLocalSearch] = useState(search);
  const placeholder = user?.role == 2 ? 'Zoek therapeut op' : 'Zoek patient op';

  const debouncedSearch = useMemo(
    () =>
    debounce((searchQuery) => {
      localStorage.setItem("QUERYMAIL", searchQuery);
      onSearchChange?.(searchQuery);
    }, 300),
    [onSearchChange]
  );

  useEffect(() => {
    setLocalSearch(search || "");
  }, [search]);

  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

  return (
    <div className="w-full items-center px-1">
      <Input
        value={localSearch}
        placeholder={placeholder}
        className="mt-1 block w-full rounded-lg border border-wa-border bg-wa-panel py-2 pl-3 pr-3 text-sm text-wa-text outline-none ring-0 placeholder:text-wa-muted focus:border-wa-accent focus:ring-1 focus:ring-wa-accent sm:text-sm/6"
        onChange={(event) => {
          setLocalSearch(event.target.value);
          debouncedSearch(event.target.value);
        }}
      />
    </div>
  );
};

export default SelectPatientMail;
